import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Login from './Login';
import BusinessCard from './BusinessCard';
import { Link, useNavigate, useParams } from 'react-router-dom'
import './Home.css'
import myImage from '../assets/Smart-ID.png'

export default function Home() {
  return (
    <div className="about">
    <h1>Welcome</h1>
    <h2>Smart Connect</h2>
    <img src={myImage} style={{width: '200px', marginTop: '20px', marginRight:'300px'}}/>
    <p>Smart Connect is revolutionizing professional networking with a smart, 
      streamlined solution designed for today’s fast-paced, digital-first world. 
      By fusing modern NFC technology with a powerful mobile and web-based platform, 
      Smart Connect empowers professionals to seamlessly share, manage, 
      and evolve their digital identity—all in real time.</p>

    <h2>Our Mission</h2>
    <p>To redefine the way professionals connect, communicate, and leave lasting 
      impressions—eliminating outdated paper business cards in favor of a smart, 
      sustainable, and data-driven solution.</p>

    <h2>What We Offer</h2>
    <h3>1. Smart Digital Business Card</h3>
    <p>Our minimalist NFC-enabled physical card allows users to instantly share 
      contact details with a simple tap. Each card links to a customizable digital 
      profile—housing everything from resumes and portfolios to LinkedIn, 
      social media, and websites.</p>
    
    <h3>2. Dynamic Profile Management</h3>
    <p>Stay current. Users can effortlessly update their digital profiles through 
      our intuitive web and mobile app, syncing changes across their professional
       network instantly.</p>

    <h3>3. Networking Insights & AI Engagement</h3>
    <p>We don’t just facilitate connections—we help you grow them. 
      Smart Connect offers in-depth analytics on profile visits and engagement, 
      alongside AI-powered suggestions for new networking opportunities and tailored job matches.</p>
    
    <h3>4. Business Card Repair & Update Service</h3>
    <p>Eliminate outdated contact info. Our repair service ensures that 
      corrections are automatically updated for both existing and future 
      connections—keeping your network accurate and up to date.</p>

    <h3>5. Legacy Resume Vault</h3>
    <p>Smart Connect uniquely honors professional legacies. 
      Our Legacy Resume Vault preserves and shares the resumes of deceased professionals, 
      allowing families, businesses, and institutions to maintain their lasting contributions 
      and career histories.</p>

    <h2>Who We Serve</h2>
    <ul>
      <li>Professionals and entrepreneurs seeking a modern, efficient way to network</li>
      <li>Job seekers looking to showcase their skills and resumes dynamically</li>
      <li>Recruiters and hiring managers requiring streamlined resume collection</li>
      <li>Businesses aiming to enhance branding and employee networking</li>
    </ul>

    <h2>Revenue Model</h2>
    <ul>
      <li>Subscription Plans for premium features and analytics</li>
      <li>One-Time Card Purchases with customizable branding</li>
      <li>Corporate Packages tailored for teams and branded internal networking</li>
    </ul>

    <h2>Why Smart Connect</h2>
    <p>We’re more than just a digital business card—we’re a professional evolution. 
      With real-time updates, powerful analytics, and a one-of-a-kind legacy feature, 
      Smart Connect offers a competitive edge in an ever-changing professional landscape.</p>
      <br/>
      <br/>
      <p>Let Smart Connect be your first impression—and your lasting one.</p>
  </div>
  );
}

